var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-selector',_vm._g(_vm._b({staticClass:"hub-selector",attrs:{"items":_vm.hubIds,"placeholder":_vm.$t('navbar.hubSelector.placeholder'),"getItemLabel":_vm.getHubShortCode}},'custom-selector',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }